import React, { useState } from 'react';
import { Bell, BellOff, Smartphone, Share, Plus, X } from 'lucide-react';
import { usePushNotifications } from '../hooks/usePushNotifications';
import { Button } from './ui/button';

const PushNotificationManager: React.FC = () => {
  const {
    isSupported,
    isSubscribed,
    loading,
    isIOS,
    isStandalone,
    subscribeUser,
    unsubscribeUser,
  } = usePushNotifications();

  const [showIOSHelp, setShowIOSHelp] = useState(false);

  // iOS no Safari (não instalado): mostrar guia "Adicionar à Tela de Início"
  if (isIOS && !isStandalone) {
    return (
      <>
        <Button
          variant="default"
          size="sm"
          onClick={() => setShowIOSHelp(true)}
          className="flex items-center space-x-2"
        >
          <Smartphone className="w-4 h-4" />
          <span>Ativar Push (iPhone)</span>
        </Button>

        {showIOSHelp && (
          <div className="fixed inset-0 z-[100] bg-black/50 flex items-end sm:items-center justify-center p-4">
            <div className="bg-white rounded-2xl w-full max-w-md p-5 shadow-xl">
              <div className="flex items-start justify-between mb-3">
                <h3 className="text-lg font-semibold text-gray-900">
                  Instalar Fox Vendas no iPhone
                </h3>
                <button
                  onClick={() => setShowIOSHelp(false)}
                  className="text-gray-400 hover:text-gray-600"
                >
                  <X className="w-5 h-5" />
                </button>
              </div>
              <p className="text-sm text-gray-600 mb-4">
                No iPhone, notificações push só funcionam com o app instalado na tela
                de início. Siga os passos abaixo no <strong>Safari</strong>:
              </p>
              <ol className="space-y-3 text-sm text-gray-800">
                <li className="flex items-start gap-3">
                  <span className="flex-shrink-0 w-6 h-6 rounded-full bg-orange-100 text-orange-600 font-semibold flex items-center justify-center">1</span>
                  <div className="flex-1">
                    Toque no botão <Share className="inline w-4 h-4 mx-1 text-blue-600" /> <strong>Compartilhar</strong> na barra inferior do Safari.
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <span className="flex-shrink-0 w-6 h-6 rounded-full bg-orange-100 text-orange-600 font-semibold flex items-center justify-center">2</span>
                  <div className="flex-1">
                    Role e toque em <Plus className="inline w-4 h-4 mx-1" /> <strong>Adicionar à Tela de Início</strong>.
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <span className="flex-shrink-0 w-6 h-6 rounded-full bg-orange-100 text-orange-600 font-semibold flex items-center justify-center">3</span>
                  <div className="flex-1">
                    Abra o app <strong>Fox Vendas</strong> pelo ícone na tela de início.
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <span className="flex-shrink-0 w-6 h-6 rounded-full bg-orange-100 text-orange-600 font-semibold flex items-center justify-center">4</span>
                  <div className="flex-1">
                    Toque em <strong>Ativar Push</strong> dentro do app e confirme a permissão.
                  </div>
                </li>
              </ol>
              <div className="mt-4 p-3 bg-amber-50 border border-amber-200 rounded-lg text-xs text-amber-800">
                Requer iOS 16.4 ou superior. Funciona apenas pelo Safari (não pelo Chrome no iPhone).
              </div>
              <Button
                onClick={() => setShowIOSHelp(false)}
                className="w-full mt-4"
              >
                Entendi
              </Button>
            </div>
          </div>
        )}
      </>
    );
  }

  if (!isSupported) {
    return null;
  }

  return (
    <div className="flex items-center space-x-2">
      <Button
        variant={isSubscribed ? "secondary" : "default"}
        size="sm"
        onClick={isSubscribed ? unsubscribeUser : subscribeUser}
        disabled={loading}
        className="flex items-center space-x-2"
      >
        {isSubscribed ? (
          <>
            <BellOff className="w-4 h-4" />
            <span>Desativar Push</span>
          </>
        ) : (
          <>
            <Bell className="w-4 h-4" />
            <span>Ativar Push</span>
          </>
        )}
      </Button>
    </div>
  );
};

export default PushNotificationManager;
